// Smart Sash Admin Panel - Login Form Component
// Form for user authentication

import { LoginRequest } from '@/models';
import { useAuth } from '@/services/auth';
import React, { useState } from 'react';

/**
 * Login Form Component
 */
export const LoginForm: React.FC = () => {
  const { login, isLoading, error } = useAuth();
  const [loginIdentifier, setLoginIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [localError, setLocalError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLocalError(null);

    // Validation
    if (!loginIdentifier || !password) {
      setLocalError('Username or email and password are required');
      return;
    }

    try {
      const credentials: LoginRequest = {
        login: loginIdentifier,
        password,
      };
      await login(credentials);
    } catch (err) {
      // Error is already set in auth context
      console.error('Login error:', err);
    }
  };

  const displayError = localError || error;

  return (
    <form onSubmit={handleSubmit}>
      {displayError && (
        <div className="alert alert-danger" role="alert">
          <i className="fas fa-exclamation-circle me-2"></i>
          {displayError}
        </div>
      )}

      <div className="mb-3">
        <label htmlFor="login" className="form-label">
          Username
        </label>
        <input
          type="text"
          className="form-control"
          id="login"
          value={loginIdentifier}
          onChange={(e) => setLoginIdentifier(e.target.value)}
          disabled={isLoading}
          autoComplete="username"
          placeholder="Enter your username"
          required
        />
      </div>

      <div className="mb-3">
        <label htmlFor="password" className="form-label">
          Password
        </label>
        <input
          type="password"
          className="form-control"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={isLoading}
          autoComplete="current-password"
          placeholder="Enter your password"
          required
        />
      </div>

      <div className="mb-3 form-check">
        <input type="checkbox" className="form-check-input" id="remember" />
        <label className="form-check-label" htmlFor="remember">
          Remember me
        </label>
      </div>

      <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
        {isLoading ? (
          <>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            Signing in...
          </>
        ) : (
          <>
            <i className="fas fa-sign-in-alt me-2"></i>
            Sign In
          </>
        )}
      </button>

      <div className="text-center mt-3">
        <a href="#" className="text-muted small">
          Forgot password?
        </a>
      </div>
    </form>
  );
};

export default LoginForm;
